export const FlameMark = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />
  </svg>
);

export const Logo = ({ className = "", testId = "logo-link" }) => (
  <a href="#top" data-testid={testId} className={`group flex items-center gap-2.5 ${className}`}>
    <span className="grid h-9 w-9 place-items-center rounded-lg bg-flame text-coal transition-transform duration-300 group-hover:rotate-6 group-hover:scale-105 flame-glow">
      <FlameMark className="h-5 w-5" />
    </span>
    <img src="/kndla-tag-white.png" alt="KNDLA" className="h-6 w-auto -rotate-2" />
  </a>
);
